import qs from 'qs';
import axios from 'axios'

// code that reaches out to imgur API
const CLIENT_ID = 'c4a652537d6a4cb';
const ROOT_URL = 'https://api.imgur.com'



export default {
    login() {
        const querystring = {
            client_id: CLIENT_ID,
            response_type: 'token'
        }; 
        window.location = `${ROOT_URL}/oauth2/authorize?${qs.stringify(querystring)}`;
    
    },
    fetchImages(token) {
        return axios.get(`${ROOT_URL}/3/account/me/images`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
    }, 
    uploadImages(images, token) {
        // initiate upload image process for EACH image uploaded
        const promises = Array.from(images).map(image => {
            const formData = new FormData();
            formData.append('image', image);

            return axios.post(`${ROOT_URL}/3/image`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

        });
        // takes an array of promises and waits for them all to be resolved before the function will continue
        return Promise.all(promises);
    }
};
